import { useIntl } from 'react-intl'
import { Avatar, Button, Chip, FontIcon } from 'react-md'
import styled from 'styled-components'
import DropdownField from 'ui/components/DropdownField'
import { useState } from 'react'

const Container = styled.div`
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	margin-bottom: 1rem;
`

const assigneesList = ['Tomi Tolonen', 'Tuomas Jurvelin', 'Esa Piiroinen']

const Assignees = () => {
	const intl = useIntl()
	const [selectedAssignee, setSelectedAssignee] = useState<string>('')

	const filteredAssignees =
		selectedAssignee && assigneesList.includes(selectedAssignee)
			? [selectedAssignee]
			: assigneesList

	return (
		<Container>
			<div style={{ width: 180 }}>
				<DropdownField
					key="mainCategory"
					label={intl.formatMessage({
						defaultMessage: 'Käsittelijät',
						description: 'Assignees',
					})}
					value={selectedAssignee}
					_onOptionSelect={(value: string) => {
						setSelectedAssignee(value)
					}}
					options={assigneesList.map((assignee) => ({
						label: assignee,
						value: assignee,
					}))}
					itemLabel="label"
					itemValue="value"
					hasSelectAll={true}
					nullSelectAll={true}
				/>
			</div>
			<div
				style={{
					display: 'grid',
					gridTemplateColumns: '1fr 1fr',
				}}
			>
				{filteredAssignees.map((assignee) => (
					<Chip
						key={assignee}
						label={assignee}
						labelStyle={{ fontSize: '14px' }}
						style={{ marginTop: 8, cursor: 'pointer', width: 180 }}
						avatar={<Avatar icon={<FontIcon>delete</FontIcon>} suffix="grey" />}
						onClick={() => {}}
					/>
				))}
			</div>
			<Button secondary raised style={{ marginTop: '1rem' }}>
				{intl.formatMessage({
					defaultMessage: 'Lähetä kierrätykseen',
					description: 'Send for recycling',
				})}
			</Button>
		</Container>
	)
}

export default Assignees
